var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"category"}},[_c('table',{staticClass:"motion-switcher-table"},[_c('tbody',[_c('tr',_vm._l((_vm.categories),function(categorie,index){return _c('th',{key:index,class:[
            'category',
            categorie.name + '-box',
            { active: index === _vm.active },
            { 'on-hover': index === _vm.active } ],on:{"click":function($event){return _vm.onSelect(index)}}},[_vm._v(" "+_vm._s(categorie.title)+" ")])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }